import React from "react";

const SITE_ORIGIN = "https://www.adsfux.de";
const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}/og-image.jpg`;

function setMeta(id, attr, attrValue, content) {
  if (!content) return;
  let el = document.querySelector(`#${id}`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("id", id);
    el.setAttribute(attr, attrValue);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(id, rel, href) {
  if (!href) return;
  let el = document.querySelector(`#${id}`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("id", id);
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Hält Titel, Description, canonical und Social-Tags synchron mit der Route.
 *
 * @param {object}  opts
 * @param {string}  opts.title        Seitentitel
 * @param {string}  opts.description  Meta-Description
 * @param {string} [opts.path]        Pfad der Seite (z.B. "/audit"). Default "/".
 * @param {string} [opts.image]       Absolute OG-Bild-URL. Default og-image.jpg.
 */
export default function usePageMetadata({ title, description, path = "/", image } = {}) {
  React.useEffect(() => {
    const url = `${SITE_ORIGIN}${path === "/" ? "/" : path.replace(/\/$/, "")}`;
    const ogImage = image || DEFAULT_OG_IMAGE;

    if (title) {
      document.title = title;
      setMeta("og-title", "property", "og:title", title);
      setMeta("tw-title", "name", "twitter:title", title);
    }

    if (description) {
      let meta = document.querySelector("#app-meta-description");
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("id", "app-meta-description");
        meta.setAttribute("name", "description");
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", description);

      document
        .querySelectorAll('meta[name="description"]:not(#app-meta-description)')
        .forEach((node) => node.remove());

      setMeta("og-description", "property", "og:description", description);
      setMeta("tw-description", "name", "twitter:description", description);
    }

    setLink("app-canonical", "canonical", url);
    setMeta("og-url", "property", "og:url", url);
    setMeta("og-image", "property", "og:image", ogImage);
    setMeta("tw-image", "name", "twitter:image", ogImage);
  }, [title, description, path, image]);
}
